import React, { lazy } from 'react';
const story = [{
  src: '//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-0.jpg?opt=w3',
  title: 'Extend Your Step with Boarding Ladder up',
  alt: 'Extend Your Step with Boarding Ladder up',
  caption: 'This is the Extend Your Step with the boarding ladder up.'
}, {
  src: '//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-1.jpg?opt=w3',
  title: 'EYS-1',
  alt: 'Extend Your Step on Boarding Ladder',
  caption: 'Extend Your Step stays right on your boarding ladder, so you never need to store it.'
}, {
  src: '//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-2c.jpg?opt=w3',
  title: 'Extend Your Step on Boarding Ladder swinging down',
  alt: 'Extend Your Step on Boarding Ladder swinging down',
  caption: 'Extend Your Step stays new-looking and cleans up easily with soap and water when needed.'
}, {
  src: '//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-3.jpg?opt=w3',
  title: 'Boarding Ladder',
  alt: 'Standing on boarding ladder last step',
  caption: 'Standing on the bottom rung of my sailboat\u2019s boarding ladder requires a big step up from the water.'
}, {
  src: '//drwzpk38qkpfb.cloudfront.net/www.clrmarine.com/preview/uploaded/images/EXTEND_YOUR_STEP/EYS-5a.jpg?opt=w3',
  title: "On Extend Your Step it's a lot easier getting on board",
  alt: "On Extend Your Step it's a lot easier getting on board",
  caption: 'With Extend Your Step it\u2019s much easier for me to get on board as it extends well into the water.'
}];
export function EysStory() {
  return <section className="w-full bg-white" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-192">
        <div className="mb-8 text-center max-w-2xl mx-auto" data-id="element-193">
          <div className="inline-flex items-center gap-2 text-marine-blue text-xs font-semibold uppercase tracking-wider mb-3" data-id="element-194">
            See It In Use
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-marine-navy mb-2" data-id="element-195">
            How Extend Your Step Works
          </h2>
          <p className="text-slate-600" data-id="element-196">
            From stowed to deployed — a closer look at how Extend Your Step
            makes getting back aboard easier.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-197">
          {story.map((item, i) => <figure key={item.src} className="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200 flex flex-col" data-id="element-198">
              <div className="relative bg-slate-100" data-id="element-199">
                <img src={item.src} alt={item.alt} title={item.title} loading="lazy" className="w-full aspect-[4/3] object-contain" data-id="element-200" />
                <div className="absolute top-3 left-3 bg-marine-navy/90 text-white text-xs font-bold w-7 h-7 rounded-full flex items-center justify-center shadow-md" data-id="element-201">
                  {i + 1}
                </div>
              </div>
              <figcaption className="p-4 text-sm text-slate-700 leading-relaxed flex-1" data-id="element-202">
                {item.caption}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}